import { useEffect, useState } from 'react';

import { DEFAULT_LOCALE, type LazyI18nMessages } from './ProFormaIntlProvider';

const localeRegex = /([a-z]+)(?:[-_]([A-Z]+))?/i;

export const getCodesFromLocale: (locale: string) => {
	language: string;
	country: string | undefined;
} = (locale: string): { language: string; country: string | undefined } => {
	let match = localeRegex.exec(locale);
	if (!match) {
		// eslint-disable-next-line no-console
		console.error(
			'Unable to get language and country from invalid locale, falling back to default locale.',
		);
		match = localeRegex.exec(DEFAULT_LOCALE)!;
	}
	const [, language, country] = match;

	return {
		language: language.toLowerCase(),
		country: country?.toUpperCase(),
	};
};

const loadLazyI18nMessages = async (
	locale: string,
	lazyI18nMessages: LazyI18nMessages,
): Promise<Record<string, string>> => {
	const { language, country } = getCodesFromLocale(locale);

	return (
		(
			await (
				(country && lazyI18nMessages[`${language}_${country}`]) ||
				lazyI18nMessages[language] ||
				lazyI18nMessages.en
			)?.()
		)?.default ?? {}
	);
};

export const useLazyI18nMessages: (
	locale: string,
	lazyI18nMessages: LazyI18nMessages,
) => Record<string, string> | undefined = (locale: string, lazyI18nMessages: LazyI18nMessages) => {
	const [messages, setMessages] = useState<Record<string, string>>();

	useEffect(() => {
		loadLazyI18nMessages(locale, lazyI18nMessages)
			.catch(() => ({}))
			.then(setMessages);
	}, [locale, setMessages, lazyI18nMessages]);

	return messages;
};
